<template>
  <div class="spliter">
    <div class="spliter-con">
      <knwlg-lib-adm modalType="dimsKnowledge"/>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import commonMixin from "@/mixins/commonMixin";
import { Multipane, MultipaneResizer } from "vue-multipane";
import IdcSearchCatalog from "@/components/IdcSearchCatalog.vue";
import IdcTree from "@/components/common/IdcTree";
import IdcList from "@/components/common/IdcList";
import IdcNoData from "@/components/common/IdcNoData";
import KnwlgLibAdm from "@/views/ossPortalAdm/KnwlgLibAdm.vue";

export default {
  name: "Home",
  layout: "LyWide",
  mixins: [commonMixin],
  components: {
    Multipane,
    MultipaneResizer,
    IdcSearchCatalog,
    IdcTree,
    IdcList,
    IdcNoData,
    KnwlgLibAdm,
  },
  created() {
    this.$EventBus.$on("rowClick", (row) => {
      this.listViewClick = true;
    });
  },
  data() {
    return {
      count: 25,
      countList: [
        {
          value: 10,
          label: "10개",
        },
        {
          value: 25,
          label: "25개",
        },
        {
          value: 50,
          label: "50개",
        },
      ],
      activeName: "regInfo",
      treeList: [
        {
          id: "1",
          label: "안전교육자료",
          children: [
            {
              id: "1-1",
              label: "목동1IDC",
            },
            {
              id: "1-2",
              label: "목동2IDC",
            },
            {
              id: "1-3",
              label: "강남IDC",
            },
          ],
        },
      ],

      tableHeader: [
        {
          prop: "col1",
          label: "NO",
          width: "3.5",
        },
        {
          prop: "col2",
          label: "IDC",
          width: "4.5",
        },
        {
          prop: "col3",
          label: "자료유형",
          width: "7",
        },
        {
          prop: "col4",
          label: "위치",
          width: "5",
        },
        {
          prop: "col5",
          label: "-",
          width: "4.5",
        },
      ],
      tableData: [],

      tableHeader2: [
        {
          type: "selection",
          align: "left",
        },
        {
          prop: "col1",
          label: "No",
          width: "6.5",
        },
        {
          prop: "col2",
          label: "파일명",
        },
      ],
      tableData2: [
        {
          col1: 1,
          col2: "안전교육자료.xls",
        },
        {
          col1: 2,
          col2: "안전교육자료.xls",
        },
        {
          col1: 3,
          col2: "안전교육자료.xls",
        },
        {
          col1: 4,
          col2: "안전교육자료.xls",
        },
      ],

      breadcrumbList: [
        {
          link: "/",
          breadcrumb: "HOME",
        },
        {
          link: "/",
          breadcrumb: "서비스관리",
        },
        {
          link: "/",
          breadcrumb: "서비스카탈로그관리",
        },
      ],
      filter: "",
      allCheck: false,
      filterFormData: {
        list1: [
          {
            label: "전체",
            vaule: 1,
          },
        ],
        list2: [
          {
            label: "전체",
            vaule: 1,
          },
        ],
        list3: [
          {
            label: "전체",
            vaule: 1,
          },
          {
            label: "전체",
            vaule: 2,
          },
          {
            label: "전체",
            vaule: 3,
          },
        ],
      },
      filterDataServiceCatalog: {
        catalog: {
          searchText: "",
          select1: "",
          select2: "",
          select3: "",
        },
        name: "",
        catalogName: "",
        workFlowName: "",
      },
      filterDataWorkflow: {
        catalog: {
          searchText: "",
          select1: "",
          select2: "",
          select3: "",
        },
        name: "",
        catalogName: "",
        workFlowName: "",
      },
      listViewClick: false,
    };
  },
  methods: {
    onMinus(item) {
      console.log(item);
    },
    pushData() {
      this.tableData = [];
      for (let i = 1; i < 30; i++) {
        this.tableData.push({
          col1: i,
          col2: "목동1",
          col3: "안전교육자료",
          col4: "1층",
          col5: "-",
        });
      }
    },
    nodeClick(item, node) {
      this.listViewClick = false;
      if (node.label === "목동1IDC") {
        console.log("clck");
        this.pushData();
      } else {
        this.tableData = [];
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.list-scrollX {
  min-width: 600px;
}

.detail-box {
  min-width: 940px;
}

.content-detail {
  overflow-x: auto;
}
</style>
